import * as Schema from "effect/Schema";
import { PortSchema } from "./baseSchemas.js";
export const DesktopBackendBootstrap = Schema.Struct({
    mode: Schema.Literal("desktop"),
    noBrowser: Schema.Boolean,
    port: PortSchema,
    t3Home: Schema.String,
    host: Schema.String,
    /**
     * An already-minted Dovod server-authorization token (audience `dovod-server`, 15-minute
     * expiry) that lets the server start warm instead of waiting for the renderer's first mint.
     * The server verifies it offline against a cached JWKS. Optional because the desktop shell
     * may spawn the server before the user has signed in, and the server must still start and
     * serve the sign-in surface.
     */
    initialToken: Schema.optionalKey(Schema.String),
    tailscaleServeEnabled: Schema.Boolean,
    tailscaleServePort: PortSchema,
    otlpTracesUrl: Schema.optional(Schema.String),
    otlpMetricsUrl: Schema.optional(Schema.String),
});
